import { useTheme } from '@mui/material/styles';

// "B" da Boneside (extraído do wordmark oficial). Cor segue text.primary via CSS var,
// adaptando ao tema claro/escuro. Usado na sidebar recolhida.
export default function LogoIcon() {
  const theme = useTheme();
  return (
    <svg height="32" viewBox="0 0 65 92" fill="none" role="img" aria-label="Boneside"
      style={{ color: theme.vars!.palette.text.primary, width: 'auto', display: 'block' }} xmlns="http://www.w3.org/2000/svg">
      <path d="M41.9297 3C54.4669 3.00013 64.6309 13.164 64.6309 25.7012L64.624 26.2871C64.318 38.3588 54.5874 48.0888 42.5156 48.3945L41.9307 48.4014H0V41.9922H41.9307C50.9276 41.9918 58.2215 34.6981 58.2217 25.7012C58.2217 16.7039 50.9269 9.40931 41.9297 9.40918H0V3H41.9297Z" fill="currentColor" />
      <path d="M41.9297 43.5938C54.4669 43.5939 64.6309 53.7577 64.6309 66.2949L64.624 66.8809C64.3178 78.9524 54.5873 88.6826 42.5156 88.9883L41.9307 88.9951H0V82.5859H41.9307C50.9275 82.5855 58.2213 75.2917 58.2217 66.2949C58.2217 57.2977 50.9269 50.0031 41.9297 50.0029H0V43.5938H41.9297Z" fill="currentColor" />
    </svg>
  );
}
